import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../redux/reducers/index'
import CardCategory from '../../components/CardCategory'
import { Banner } from '../../components/Banner';
import FreeShippingMinBanner from '../../components/FreeShippingMinBanner';
import FreeShippingProgress from '../../components/FreeShippingProgress';
import { getFreeShippingStatus } from '../../utils/shippingRules';
import { getPhysicalCartSubtotal, isDigitalProduct } from '../../utils/cartSubtotal';
import {Body, Container,Title} from '../../theme/theme'
import {useHistory} from "react-router-dom";
import {setRoute, handleResetQuote} from '../../redux/actions';
import Spinner from '../../components/Spinner'
import { language } from '../../utils/language';
const Home = () => {
    const homeState: HomeStateType = useSelector((state: RootState) => state.home)
    const categoryState: any = useSelector((state: RootState) => state.category)
    const shoppingCart: ShoppingCartStateType = useSelector((state: RootState) => state.shoppingCart)
    const aveonlineIntegration: any = useSelector((state: RootState) => state.aveonline.integration)
    const isAveonlineStore = Boolean(
        aveonlineIntegration?.status &&
            aveonlineIntegration?.wherehouseStatus === "Confirmado"
    )
    const cartItems = shoppingCart.cartInfo || []
    const hasPhysicalProducts = cartItems.some((item: any) => !isDigitalProduct(item?.productData))
    const freeShippingStatus = getFreeShippingStatus(
        homeState.shippingType,
        homeState.freeShippingMinAmount,
        getPhysicalCartSubtotal(cartItems)
    )
    const maxShowCategories = 2
    const history = useHistory()
    const dispatch = useDispatch()

    const handleCategoryDetailRedirect = (categoryId:number, categoryName:string)=>{
        dispatch(setRoute({route: '/', routeName: categoryName}))
        history.push(`/vende/${homeState.catalogueUrlName}/detailcategory/${categoryId}`)
    }



    useEffect(() => {
        dispatch(handleResetQuote())
    }, [])


        return (
            <>
                {!homeState.loading ? (
                  <>
                    <Banner arrBanner={homeState.banners} color ={homeState.color}/>
                    <Body>
                        <FreeShippingMinBanner inContent wide />
                        {!isAveonlineStore && hasPhysicalProducts && (
                            <FreeShippingProgress variant="home" status={freeShippingStatus} color={homeState.color} />
                        )}
                        <Container>
                            {homeState.outstandingValid &&<>
                                    <Title color={homeState.color} onClick={() => handleCategoryDetailRedirect(0, language[homeState.default_language]["featured"])}>{language[homeState.default_language]["featured"]}</Title>
                                    <CardCategory outstanding={true} products={homeState.outstandingData}/>
                            </> }
                            {
                                    categoryState.listCategory && categoryState.listCategory.length > 0 ?
                                    categoryState.listCategory.slice(0, maxShowCategories).map( (field: any, index:any) => (
                                        <>
                                            <Title onClick={() => handleCategoryDetailRedirect(field.id, field.name)}  color={homeState.color}>
                                                {field.name}
                                            </Title>
                                            <CardCategory categoryId={field.id} outstanding={false} products={field.products}/>
                                        </>
                                    ))
                                    : 
                                    <div></div>
                                }
                        </Container>
                    </Body>
            </>
            ) : (
                <Spinner/>
            )}            
        </>
    )
}

export default Home